import React, { Component } from "react";
import * as Http from "../../http";
import { ErrorCode } from "../../const";
import { ButtonToolbar, Button } from "react-bootstrap";
import * as Business from "../../utils/business";
import Loading from "../../components/Loading";
import { MasterTableType } from "../../const";

const PARTY_DATA = [
  { name: "INDI", value: 1 },
  { name: "CORP", value: 2 },
  { name: "FOREIGN_FI", value: 3 },
  { name: "FOREIGN_BANK", value: 4 },
  { name: "DOM_FI", value: 5 },
  { name: "SOV_VN", value: 6 },
  { name: "TREASURY_VN", value: 7 },
  { name: "LOCAL_GOV_VN", value: 8 },
  { name: "POLICY_BANK", value: 9 },
  { name: "SBV", value: 10 },
  { name: "PSE_CG", value: 11 },
  { name: "PSE_LG", value: 12 },
  { name: "IFI", value: 13 },
  { name: "LEASING_COMP", value: 14 },
  { name: "FIN_COMP", value: 15 },
  { name: "FUND", value: 16 },
  { name: "SOV_FOREIGN", value: 17 },
  { name: "VAMC", value: 18 },
  { name: "DATC", value: 19 },
  { name: "OTHERS", value: 20 },
];

const LOAN_DATA = [
  { name: "SECURITIES", value: 1 },
  { name: "REAL_ESTATE", value: 2 },
  { name: "HOUSING", value: 3 },
  { name: "SOCIAL_HOUSING", value: 4 },
  { name: "SPECIAL_TT14", value: 5 },
  { name: "PROJECT_FIN", value: 5.1 },
  { name: "OBJECT_FIN", value: 5.2 },
  { name: "COMMODITIES", value: 5.3 },
  { name: "INVEST_TFI", value: 6 },
  { name: "ENTRUSTED", value: 7 },
  { name: "OTHERS", value: 8 },
  { name: "AGRI_RURAL", value: 11 },
];

const COLLATERAL_DATA = [
  { name: "COLL_RE", value: 1 },
  { name: "COLL_CORP_BOND", value: 2 },
  { name: "COLL_EQTY", value: 3 },
  { name: "COLL_GOV_VN", value: 4 },
  { name: "COLL_SELF_DC", value: 5 },
  { name: "COLL_OTHER_DC", value: 6 },
  { name: "COLL_SELF_DEP", value: 7 },
  { name: "COLL_CASH", value: 8 },
  { name: "COLL_GOLD", value: 9 },
  { name: "COLL_FOREIGN_GOV", value: 10 },
  { name: "COLL_GUAR", value: 11 },
  { name: "COLL_NETTING", value: 12 },
  { name: "COLL_CDS", value: 13 },
  { name: "COLL_OTHERS", value: 14 },
];

const PRODUCT_DATA = [
  { name: "INVEST", value: 1 },
  { name: "BOND", value: 2 },
  { name: "REPO", value: 3 },
  { name: "SPOT", value: 4 },
  { name: "LEND", value: 5 },
  { name: "CARD", value: 6 },
  { name: "PAYMT", value: 7 },
  { name: "GUAR", value: 8 },
  { name: "FINCOM", value: 9 },
  { name: "LC", value: 10 },
];

export default class MasterTableChild extends Component {
  constructor(props) {
    super(props);
    this.type = props.type;
    this.state = {
      loading: true,
      data: [],
      dataOld: [],
      showDeleteAlert: false,
      editedData: null,
    };
    this.usernameWillDelete = null;
  }

  componentDidMount() {
    this.getListMasterTables();
  }

  getTitleScreen() {
    switch (this.type) {
      case MasterTableType.party_type:
        return "Party Type";
      case MasterTableType.business_sector:
        return "Business Sector";
      default:
        return "";
    }
  }

  getListMasterTables = () => {
    this.setState({
      loading: false,
    });
    Http.getMasterTableByType(this.type).then((res) => {
      const data = [];
      if (res && res.Data) {
        var lstData = Array.isArray(res.Data)
          ? res.Data.sort((a, b) =>
              a.time_changed.localeCompare(b.time_changed)
            )
          : [];
        var lastIndex = lstData.length - 1;
        for (let index = 0; index < lstData.length; index++) {
          const element = res.Data[index];
          var obj = element;
          obj.index = index;
          if (index != lastIndex) {
            obj.isLastItem = false;
          } else {
            obj.isLastItem = true;
          }
          data.push(obj);
        }
      }
      this.setState({
        loading: false,
        data: data,
        dataOld: data,
      });
    });
  };

  onValidate = (lstData) => {
    const dicCheckNameExist = {};
    // Check ban ghi ton tai
    for (let i = 0; i < lstData.length; i++) {
      const obj = lstData[i];
      if (dicCheckNameExist.hasOwnProperty(obj.name)) {
        return `${obj.name} record already exists`;
      }
      if (!obj.name) {
        return `'Name' must not be null`;
      }
      dicCheckNameExist[obj.name] = obj.name;
    }
    return null;
  };

  onUpdateData = () => {
    const dataToValidate = this.state.editedData || this.selectData(this.props.title);
    const errorMsg = this.onValidate(dataToValidate);
    if (errorMsg) {
      Business.showAlert({
        title: "Error",
        content: errorMsg,
      });
      return;
    }

    // Update the state with the current edited data
    const currentData = dataToValidate.map(item => ({
      ...item,
      isEditing: false
    }));

    this.setState(
      {
        data: currentData,
        editedData: currentData,
        loading: true,
      },
      () => {
        const listData = currentData.map(obj => ({
          name: obj.name,
          value: obj.value,
          type: this.type
        }));

        Http.updateMasterTable(listData, this.type).then((res) => {
          this.handleErrorCode(res);
          this.getListMasterTables();
        });
      }
    );
  };

  onCancel = () => {
    this.setState({
      data: this.state.dataOld,
    });
  };

  onAddItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));

    data.splice(index + 1, 0, {
      name: "",
      value: 0,
      type: this.type,
    });
    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.index = index;
      if (index != lastIndex) {
        obj.isLastItem = false;
      } else {
        obj.isLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  };

  onRemoveItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    if (index > -1) {
      data.splice(index, 1);
    }
    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.index = index;
      if (index != lastIndex) {
        obj.isLastItem = false;
      } else {
        obj.isLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  };

  handleErrorCode(res) {
    if (res) {
      if (res.ErrorCode) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You do not have permission",
            });
            break;
          default:
            Business.showAlert({
              title: "Error",
              content: res.Data || "Unknow Error",
            });
            break;
        }
      } else {
        Business.showAlert({ title: "Info", content: "Successfully" });
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  selectData = (title) => {
    const baseData = (() => {
      switch (title) {
        case "Party Type":
          return PARTY_DATA;
        case "Loan Purpose Type":
          return LOAN_DATA;
        case "Collateral Type":
          return COLLATERAL_DATA;
        case "Product Type":
          return PRODUCT_DATA;
        default:
          return [];
      }
    })();
    
    return this.state.editedData || baseData;
  };

  renderRow = (index, isLastItem) => {
    const classNameAddLessIcon = isLastItem ? "pe-7s-plus" : "pe-7s-less";
    const classNameAddIcon = "pe-7s-plus";
    const classNameLessIcon = "pe-7s-less";
    return this.state.data[index] ? (
      <tr key={index}>
        <td>
          <input
            type="text"
            style={{ width: "80%" }}
            value={this.state.data[index].name}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.name = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </td>
        <td>
          <input
            type="number"
            min="0"
            max="100"
            style={{ width: "50%" }}
            value={this.state.data[index].value}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.value = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </td>
        <td>
          <i
            className={classNameLessIcon}
            style={{ fontSize: 27, cursor: "pointer" }}
            onClick={() => {
              return this.onRemoveItem(index);
            }}
          />

          <i
            className={classNameAddIcon}
            style={{ fontSize: 27, cursor: "pointer" }}
            onClick={() => {
              return this.onAddItem(index);
            }}
          />
        </td>
      </tr>
    ) : (
      <tr key={index}>
        <td>
          <input
            type="text"
            style={{ width: "80%" }}
            value={""}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.name = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </td>
        <td>
          <input
            type="number"
            min="0"
            max="100"
            style={{ width: "50%" }}
            value={0}
            onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.value = event.target.value;
              data[index] = obj;
              this.setState({ data });
            }}
          />
        </td>
        <td>
          <i
            className={classNameLessIcon}
            style={{ fontSize: 27, cursor: "pointer" }}
            onClick={() => {
              return this.onRemoveItem(index);
            }}
          />

          <i
            className={classNameAddIcon}
            style={{ fontSize: 27, cursor: "pointer" }}
            onClick={() => {
              return this.onAddItem(index);
            }}
          />
        </td>
      </tr>
    );
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    const listRender = [];
    this.state.data.forEach((e) => {
      listRender.push(this.renderRow(e.index, e.isLastItem));
    });
    return (
      <div className="card">
        <div className="header">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <h4 className="title">{this.props.title}</h4>
            <ButtonToolbar>
              <Button
                bsSize="small"
                style={{
                  borderRadius: "5px",
                  marginRight: "2px",
                  fontWeight: 600,
                  marginLeft: "auto",
                }}
                onClick={() => {
                  this.onUpdateData();
                }}
                active
              >
                Update
              </Button>
              <Button
                bsSize="small"
                style={{
                  borderRadius: "5px",
                  marginRight: "2px",
                  fontWeight: 600,
                  marginLeft: "auto",
                }}
                active
              >
                Submit
              </Button>
              <Button
                bsSize="small"
                style={{
                  borderRadius: "5px",
                  marginRight: "2px",
                  fontWeight: 600,
                  marginLeft: "auto",
                }}
                active
              >
                Approval
              </Button>
              <Button
                bsSize="small"
                style={{
                  borderRadius: "5px",
                  fontWeight: 600,
                  marginLeft: "auto",
                }}
                onClick={() => {
                  this.onCancel();
                }}
                active
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.selectData(this.props.title).map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.isEditing ? (
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => {
                          const newData = [...(this.state.editedData || this.selectData(this.props.title))];
                          newData[index] = { ...newData[index], name: e.target.value };
                          this.setState({ editedData: newData });
                        }}
                      />
                    ) : item.name}</td>
                    <td>{item.isEditing ? (
                      <input
                        type="number"
                        value={item.value}
                        onChange={(e) => {
                          const newData = [...(this.state.editedData || this.selectData(this.props.title))];
                          newData[index] = { ...newData[index], value: Number(e.target.value) };
                          this.setState({ editedData: newData });
                        }}
                      />
                    ) : item.value}</td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button onClick={() => {
                          const currentData = this.state.editedData || [...this.selectData(this.props.title)];
                          const newRow = { name: "", value: 0, isEditing: true };
                          const newData = [
                            ...currentData.slice(0, index),
                            newRow,
                            ...currentData.slice(index)
                          ];
                          this.setState({ editedData: newData });
                        }}>+</button>
                        <button onClick={() => {
                          const currentData = this.state.editedData || [...this.selectData(this.props.title)];
                          const newData = currentData.filter((_, i) => i !== index);
                          this.setState({ editedData: newData });
                        }}>-</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MasterTable/MasterTableChild.js